import { Typography } from "@heroui/react";

import { formatDateTime } from "@/utils/date";

export const EmptyRowValue = ({ value = "N/A" }: { value?: string }) => {
  return (
    <Typography color="muted" type="body-sm">
      {value}
    </Typography>
  );
};

export const EmptyDash = () => (
  <Typography color="muted" type="body-sm">
    &mdash;
  </Typography>
);

export const DateRowValue = ({ value }: { value: string }) => {
  const formatted = formatDateTime(value);

  return (
    <Typography className="truncate" type="body-sm">
      {formatted}
    </Typography>
  );
};
